import "./Experience.module.css";
import Header from "@/reusable_sections/Header";
import BotanicalHeritage from "./sections/BotanicalHeritage";
import OurCulturalPillars from "./sections/OurCulturalPillars";
import SeasonSpecials from "./sections/SeasonSpecials";
import Footer from "@/reusable_sections/Footer";
export default function ExperiencePage() {
  return <div>
      <Header />
      <BotanicalHeritage />
      <OurCulturalPillars />
      <SeasonSpecials />
      <Footer />
    </div>;
}